/* eslint-disable react/jsx-quotes */
/* eslint-disable react/jsx-sort-prop-types */
/* eslint-disable no-undef */

import React, { Component } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import Switch from "react-bootstrap-switch";
import {
  getAvailabilityAndMotives,
  changeAvailabilityMultiple,
  modifyAvailablityDetail,
  setCallAvailability,
} from "../../actions/availability";
import Loader from "../Components/Loader";
import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css";
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class AvailabilityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showErr: false,
      modifiedList: [],
      availabilityList: [],
      allSelectDisabled: true,
      listHeight: 255,
      disableSave: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.availability.availabilityList !==
      this.props.availability.availabilityList
    ) {
      const obj = { ...nextProps.availability.availabilityList };
      if (obj) {
        const availabilityListAll = Object.keys(obj).map(function (key) {
          return obj[key];
        });
        this.setState(
          {
            availabilityListAll,
            availabilityList: availabilityListAll,
          },
          () => {
            this.checkAgentAvailability(this.state.availabilityListAll, true);
            this.handleSelectAllState();
          }
        );
      }
    }
  }
  // gets agents availability List and motives list
  handleEnter = () => {
    this.setState(
      {
        modifiedList: [],
        availabilityList: [],
        allSelectDisabled: true,
        loading: true,
      },
      () => {
        this.props
          .getAvailabilityAndMotives()
          .then(
            () => {
              this.setState({
                loading: false,
              });
            },
            () => {
              this.setState({
                loading: false,
                showErr: true,
                errorMsg:
                  this.props.translations.commonErrorText[
                    this.props.selectedLanguage
                  ],
                listHeight: 195,
              });
            }
          );
      }
    );
  };
  // resets state when modal is closed
  handleExit = () => {
    this.setState({
      modifiedList: [],
      availabilityList: [],
      allSelectDisabled: true,
      loading: true,
    });
  };
  /**
   * updates state_id and motive_id for list of availabilities. if we update motive id
   * then we put state id to 2 (false) which means user is not available for the servie.
   * list item which has a motive id will be false.
   * @param  {string} value      value of service id or motive id
   * @param  {string} service_id
   * @param  {string} name        either state_id or motive_id
   */
  updateState = (value, service_id, name) => {
    const modifiedList = this.state.modifiedList;
    const index = modifiedList.findIndex(
      (item) => item.service_id == service_id
    );
    if (index > -1) {
      modifiedList[index][name] = value;
      if (name === "motive_id") {
        modifiedList[index].state_id = 2;
      }
      setTimeout(() => {
        this.setState({
          modifiedList,
        });
      }, 300);
    } else {
      const data = {
        service_id,
        [name]: value,
      };
      if (name === "motive_id") {
        data.state_id = 2;
      }
      setTimeout(() => {
        this.setState({
          modifiedList: this.state.modifiedList.concat(data),
        });
      }, 300);
    }
  };

  handleSelectAllState = () => {
    const { availabilityListAll } = this.state;
    const isAnyEnabled = availabilityListAll.some((item) => item.available);
    const isAllEnabled =
      availabilityListAll.filter((item) => item.available).length ===
      availabilityListAll.length;

    if (isAllEnabled) {
      this.removeAvailabilityReasonForAll();
    }

    this.setState({ allSelectDisabled: isAnyEnabled });
  };

  removeAvailabilityReasonForAll = () => {
    const availabilityList = this.state.availabilityList;
    const modifiedList = this.state.modifiedList;
    availabilityList.map((item) => {
      const index = modifiedList.findIndex(
        (listItem) => listItem.service_id == item.id
      );

      if (index > -1) {
        modifiedList[index]["motive_id"] = null;
      } else {
        const data = { service_id: item.id };

        if (!item.available) {
          data.state_id = 2;
          data.motive_id = item.motive_id;
        }

        modifiedList.push(data);
      }
    });

    this.setState({ modifiedList });
  };

  /**
   * update switch value for all list and handles all select enabled or disabled state
   * @param  {object} e     event
   * @param  {boolean} state value of switch
   */
  handleAllSwitch = (e, state) => {
    if (state !== null) {
      const state_id = state ? 1 : 2;
      this.handleAllItemsUpdate(state_id, "state_id", true, state);
    }
    this.setState({
      allSelectDisabled: state,
    });
  };

  /**
   * updates availability of clicked list element
   * @param  {object} elem
   * @param  {boolean} state
   */
  handleSwitch(elem, state) {
    const state_id = state ? 1 : 2;
    this.updateState(state_id, elem.props.name, "state_id");
    const availabilityList = this.state.availabilityList;
    const availabilityListAll = this.state.availabilityListAll;
    const index = availabilityList.findIndex(
      (item) => item.id === elem.props.name
    );
    const index1 = availabilityListAll.findIndex(
      (item) => item.id === elem.props.name
    );
    availabilityList[index].available = state;
    availabilityListAll[index1].available = state;
    setTimeout(() => {
      this.setState(
        {
          availabilityList,
          availabilityListAll,
        },
        () => {
          this.handleSelectAllState();
        }
      );
    }, 300);
  }

  /**
   * updates motive (reason) value of selected list item
   * @param  {object} e
   * @param  {string} id
   */
  handleSelect = (e, id) => {
    this.updateState(e.target.value, id, "motive_id", true);
    const availabilityList = this.state.availabilityList;
    const availabilityListAll = this.state.availabilityListAll;
    const index = availabilityList.findIndex((item) => item.id === id);
    const index1 = availabilityListAll.findIndex((item) => item.id === id);
    availabilityList[index].motive_id = e.target.value;
    availabilityListAll[index1].motive_id = e.target.value;
    this.setState({
      availabilityList,
      availabilityListAll,
    });
  };
  // updates select value for whole list
  handleAllSelect = (e) => {
    this.handleAllItemsUpdate(e.target.value, "motive_id", false, false, true);
  };
  /**
   * update select or switch value for whole list
   * @param  {string}  value
   * @param  {string}  name           motive_id or state_id
   * @param  {boolean} isAvailability if its switch value
   * @param  {boolean}  switchValue
   */
  handleAllItemsUpdate = (value, name, isAvailability, switchValue) => {
    const availabilityList = this.state.availabilityList;
    const modifiedList = this.state.modifiedList;
    availabilityList.map((item) => {
      const index = modifiedList.findIndex(
        (listItem) => listItem.service_id == item.id
      );
      if (index > -1) {
        modifiedList[index][name] = value;
        if (name === "motive_id" && !item.available) {
          modifiedList[index].state_id = 2;
        }
      } else {
        const data = {
          service_id: item.id,
          [name]: value,
        };
        if (name === "motive_id" && !item.available) {
          data.state_id = 2;
        }
        modifiedList.push(data);
      }
      const itemData = item;
      if (isAvailability) {
        const ref = this.refs[`tel${item.id}`];
        ref.state.value = switchValue;
        itemData.available = switchValue;
      } else if (!isAvailability) {
        itemData.motive_id = value;
      }
      return itemData;
    });
    this.setState(
      {
        modifiedList,
        availabilityList,
        availabilityListAll: this.state.availabilityListAll.map((item) =>
          availabilityList.find((listItem) => listItem.id === item.id)
            ? {
                ...availabilityList.find((listItem) => listItem.id === item.id),
              }
            : { ...item }
        ),
      },
      () => {
        this.handleSelectAllState();
      }
    );
  };

  close = (key) => {
    this.setState(
      {
        showErr: false,
        listHeight: 255,
      },
      () => {
        this.props.handleClose(key);
      }
    );
  };
  /**
   * gets value for switch for item
   * @param  {string} id
   * @return {boolean}
   */
  getSwitchValue = (id) => {
    const { available } = this.state.availabilityList.find(
      (item) => item.id === id
    );
    return available;
  };
  /**
   * check the availability for service
   * @param  {object} data
   * @return {boolean}
   */
  checkIfAvailaible = (data) => {
    let available = data.available;
    const row = this.state.modifiedList.find(
      (item) => item.service_id === data.id
    );
    if (row) {
      available = row.state_id === 1 ? true : false;
    }
    return available;
  };
  /**
   * checks availability of agent, if he is available on any service.
   * and changes the icon color to idicate if agent is available or not
   * @param  {array} data
   * @param  {boolean} compare
   */
  checkAgentAvailability = (data, compare) => {
    const available = data.find((item) => item.available === compare);
    if (available) {
      this.props.setCallAvailability(true);
    } else {
      this.props.setCallAvailability(false);
    }
  };

  getReason = (reasonId) => {
    const obj = this.props.availability.motivesList.find(
      (item) => String(item.id) === reasonId
    );

    return obj && obj.name ? obj.name : "";
  };

  renderReason = (item, reason) => {
    return item.available ? "" : reason
  }

  renderList = () => {
    const value = this.state.availabilityList.find((item) => item.motive_id);
    const id = value && value.motive_id ? String(value.motive_id) : "";
    const reason = id.length ? this.getReason(id) : "";

    return this.state.availabilityList
      .sort((a, b) => {
        let nameA = a.name.toUpperCase();
        let nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      })
      .map((item) => {
        return (
          <tr
            key={item.id}
            style={{ minHeight: "53px", height: "53px" }}
            className="availability_row"
          >
            <td
              style={{
                width: 243,
              }}
            >
              <div>
                <strong>{item.name}</strong>
              </div>
              <span>{this.renderReason(item, reason)}</span>
            </td>
            <td
              style={{
                width: 145,
              }}
              className="form-inline"
            >
              <div className="form-group">
                <Switch
                  bsSize="small"
                  defaultValue={item.available}
                  onText={
                    this.props.translations.yes[this.props.selectedLanguage]
                  }
                  offText={
                    this.props.translations.no[this.props.selectedLanguage]
                  }
                  onColor="success"
                  offColor="danger"
                  ref={`tel${item.id}`}
                  animate
                  onChange={(el, state) => this.handleSwitch(el, state)}
                  name={item.id}
                />
              </div>
            </td>
            <td className="form-inline" style={{ minWidth: "253px" }}>
              <div className="form-group">
                {/* !this.checkIfAvailaible(item) &&
                <select
                  className="form-control custom-select custom-select-sm"
                  value={item.motive_id}
                //  defaultValue={item.motive_id}
                  name={`reason_${item.id}`}
                  id={`reason_${item.id}`}
                  onChange={(e) => this.handleSelect(e, item.id)}
                >
                  <option>Select</option>
                  {
                    this.props.availability.motivesList.map(list => {
                      return (
                        <option key={list.id} value={list.id}>{list.name}</option>
                      );
                    })
                  }
                </select>
                 */}
              </div>
            </td>
          </tr>
        );
      });
  };

  renderSelect = () => {
    // renders options for reasons select
    const { availabilityList } = this.state;
    const value = availabilityList.find((item) => item.motive_id);
    const selectedValue = value && value.motive_id ? value.motive_id : "Select";

    return (
      <div className="form-group" style={{ marginLeft: 6 }}>
        <select
          className={`form-control${this.props.theme} input-smm${this.props.theme} custom-select`}
          onChange={this.handleAllSelect}
          disabled={this.state.allSelectDisabled}
          value={selectedValue}
        >
          <option className={`selectoptions${this.props.theme}`}>Select</option>
          {this.props.availability.motivesList.map((list) => {
            return (
              <option className={`selectoptions${this.props.theme}`}  key={list.id} value={list.id}>
                {list.name}
              </option>
            );
          })}
        </select>
      </div>
    );
  };

  // saves data on backend
  handleSubmit = () => {
    if (this.state.modifiedList.length > 0) {
      const motivesList = this.state.availabilityList.filter((item) => {
        if (!item.available && item.motive_id && item.motive_id !== "Select") {
          return item.motive_id;
        } else {
          return 0;
        }
      });

      const motives = motivesList.map((item) => item.motive_id);
      const removedDuplicates = [...new Set(motives)];

      const currentMotive = removedDuplicates.length
        ? Number(removedDuplicates[0])
        : null;

      const telephonyList = [];

      this.state.availabilityListAll.forEach((item) => {
        telephonyList.push({
          service_id: item.id,
          state_id: item.available ? 1 : 2,
          motive_id: currentMotive,
        });
      });

      this.setState({ disableSave: true });
      this.props
        .changeAvailabilityMultiple(telephonyList)
        .then(
          (response) => {
            // checks if every response status is true.
            const allOk = response.filter((item) => item.data.result == true);
            if (allOk.length == response.length) {
              const availabilityList = this.props.availability.availabilityList;

              this.state.modifiedList.forEach((item) => {
                for (let i = 0; i < availabilityList.length; i++) {
                  if (availabilityList[i].id === item.service_id) {
                    availabilityList[i].available = item.state_id == 2 ? false : true;
                  }
                }
              });
              const availabilityListNew = Object.keys(availabilityList).map(
                function (key) {
                  return availabilityList[key];
                }
              );
              this.checkAgentAvailability(availabilityListNew, true);
              this.props.handleClose(this.props.showAvailabilityModal);
              this.setState({ disableSave: false });
            } else {
              this.setState({
                showErr: true,
                errorMsg:
                  this.props.translations.commonErrorText[
                    this.props.selectedLanguage
                  ],
                listHeight: 195,
                disableSave: false,
              });
            }
          },
          () => {
            this.setState({
              showErr: true,
              errorMsg:
                this.props.translations.commonErrorText[
                  this.props.selectedLanguage
                ],
              listHeight: 195,
              disableSave: false,
            });
          }
        );
    } else {
      this.props.handleClose(this.props.showAvailabilityModal);
      this.setState({ disableSave: false });
    }
  };
  // handles filtering of services
  handleSearchServiceChange = (e) => {
    const searchValue = e.target.value;
    const filteredList = this.state.availabilityListAll.filter((item) =>
      item.name.toLowerCase().includes(searchValue.toLowerCase())
    );
    this.setState({
      availabilityList: filteredList,
    });
  };

  handleAlertDismiss = () => {
    this.setState({
      showErr: false,
      listHeight: 255,
    });
  };

  render() {
    const { loading } = this.state;
    const { translations, selectedLanguage } = this.props;

    return (
      <Modal
        onEntered={this.handleEnter}
        show={this.props.showAvailabilityModal}
        onHide={() => this.close("showAvailabilityModal")}
        backdrop="static"
        dialogClassName="availabilityModal"
        onExited={this.handleExit}
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>
            {translations.availability[selectedLanguage]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          {this.state.showErr && (
            <div className="alertWrapper">
              <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
                <p>{this.state.errorMsg}</p>
              </Alert>
            </div>
          )}
          <div className="table-responsive">
            <div className="table-area" style={{ minWidth: 688 }}>
              <table className={`table-fixed table table${this.props.theme} table-hover${this.props.theme} m-a-0`}>
                <thead style={{ width: "100%" }}>
                  <tr>
                    <th
                      style={{ width: 150, maxWidth: 150 }}
                      className="header"
                    >
                      {translations.service[selectedLanguage]}
                    </th>
                    <th style={{ width: 88 }} className="header">
                      {translations.telephony[selectedLanguage]}
                    </th>
                    <th style={{ width: 192 }} className="header">
                      {translations.reason[selectedLanguage]}
                    </th>
                  </tr>
                  <tr>
                    <td style={{ width: 150 }}>
                      <input
                        type="text"
                        className={`form-control${this.props.theme}`}
                        placeholder={translations.search[selectedLanguage]}
                        onChange={this.handleSearchServiceChange}
                      />
                    </td>
                    <td style={{ width: 88 }}>
                      <div
                        className="telAvailableBtn"
                        title={translations.allAvailable[selectedLanguage]}
                      >
                        <Button
                          bsStyle="success"
                          onClick={(el) => this.handleAllSwitch(el, true)}
                          bsSize="small"
                        >
                          <span className="icon icon-check" />
                        </Button>
                      </div>
                      <div
                        className="unavailableBtn"
                        title={translations.allUnavailable[selectedLanguage]}
                      >
                        <Button
                          bsStyle="danger"
                          onClick={(el) => this.handleAllSwitch(el, false)}
                          bsSize="small"
                        >
                          <span className="icon icon-cross" />
                        </Button>
                      </div>
                    </td>
                    <td className="form-inline" style={{ width: 192 }}>
                      {this.renderSelect()}
                    </td>
                  </tr>
                </thead>
                <tbody style={{ maxHeight: this.state.listHeight }}>
                  {this.renderList()}
                  {!loading && this.state.availabilityList.length == 0 && (
                    <tr>
                      <td>
                        <h2>{translations.noServiceFound[selectedLanguage]}</h2>
                      </td>
                    </tr>
                  )}
                  {loading && (
                    <tr>
                      <td>
                        <h2>
                          <Loader width="20px" height="20px" />
                        </h2>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          
          <button
            type="button"
            onClick={() => this.close("showPanelSetupModal")}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
          >
            {translations.cancel[selectedLanguage]}
          </button>
          <button
            type="submit"
            onClick={this.handleSubmit}
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            data-dismiss="modal"
            disabled={this.state.disableSave}
          >
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    agentConfig: state.agentConfig,
    agentInfo: state.agentInfo,
    availability: state.availability,
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    darkMode: state.common.darkMode,
    theme: state.common.theme,
  };
}

const mapDispatchToProps = {
  getAvailabilityAndMotives,
  changeAvailabilityMultiple,
  modifyAvailablityDetail,
  setCallAvailability,
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityModal);



// WEBPACK FOOTER //
// ./src/agent/modals/availability.js